import React from 'react'
import { useTheme } from '@mui/material'
import useCustomStyles from '../../../utils/hooks/CustomStylesHook'
import SelectDoctor from './SelectDoctor'
import SelectDepartment from './SelectDepartment'
import SelectLocation from './SelectLocation'
import SelectService from './SelectService'
import SelectDates from './SelectDates'

const styles = () => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: 20,
  },
})

const SlotsInputs = () => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)

  return (
    <div className={classes?.container}>
      <SelectService />
      <SelectLocation />
      <SelectDepartment />
      <SelectDoctor />
      <SelectDates />
    </div>
  )
}

export default SlotsInputs
